// extracted by mini-css-extract-plugin
module.exports = {"embla":"CarouselV2_embla__Z6_NQ","emblaContainer":"CarouselV2_emblaContainer__McB9k"};